import { EventName } from "module/analytics/types"
import { BiconomyButton } from "module/vault/component/ModalDeposit"

import { AspectRatio, Box, Image, VStack } from "@chakra-ui/react"
import ChakraUIRenderer from "chakra-ui-markdown-renderer"
import { Card } from "component/Card"
import { ModalType } from "component/Modal/type"
import { useModal } from "container/modal"
import ReactMarkdown from "react-markdown"

const content = `
# USDC Express Bridge powered by Biconomy

Bridge USDC and receive **USDC + ETH** on Optimism in one transaction. The easiest way to start trading on Perp v2.
`

export function GaslessDeposit() {
    const { open: openBiconomyWidget } = useModal(ModalType.BICONOMY_WIDGET)

    return (
        <Card p={0} display="flex" flexDirection={"column"}>
            <AspectRatio ratio={954 / 506}>
                <Image objectFit={"cover"} src="/assets/biconomyCover.png" />
            </AspectRatio>
            <VStack flexGrow={0} align="stretch" spacing={6} p={{ base: 6, lg: 8 }} pb={{ base: 5, lg: 7 }}>
                <Box>
                    <ReactMarkdown className="markdown" components={ChakraUIRenderer()} children={content} />
                </Box>

                <BiconomyButton
                    onClick={() => {
                        openBiconomyWidget()
                    }}
                    trackingProps={{
                        eventName: EventName.BRIDGE_BICONOMY_OPEN,
                        description: `from component: promo card on homepage`,
                    }}
                >
                    Bridge with Hyphen
                </BiconomyButton>
            </VStack>
        </Card>
    )
}
